import { render, staticRenderFns } from "./vat-certificate.vue?vue&type=template&id=3761faea&scoped=true&lang=pug"
import script from "./vat-certificate.vue?vue&type=script&lang=ts"
export * from "./vat-certificate.vue?vue&type=script&lang=ts"
import style0 from "./vat-certificate.vue?vue&type=style&index=0&id=3761faea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761faea",
  null
  
)

export default component.exports